'use strict';
define([], function () {
    function Controller(
        $scope,
        settings,
        $stateParams,
        $state,
        $mdToast,
        $translate,
        ProjectsService,
        SeospiderService,
        SearchConsoleService,
        UserService,
        TimezoneService,
        $mdDialog,
        $rootScope,
        $window
    ) {
        var tabIds = ['scope', 'audit', 'tracker', 'search-console', 'competitors'];

        if ($rootScope.previousState !== 'app.project.settings') {
            $scope.backState = $rootScope.previousState;
            $scope.backParams = $rootScope.previousParams;
            $window.localStorage.setItem('backState', $scope.backState);
            $window.localStorage.setItem('backParams', JSON.stringify($scope.backParams));
        }

        if (!$scope.backState) {
            $scope.backState = $window.localStorage.getItem('backState');
            $scope.backParams = $window.localStorage.getItem('backParams');
            if (typeof $scope.backParams === 'string') {
                try {
                    $scope.backParams = JSON.parse($scope.backParams);
                } catch (error) {
                    $scope.backParams = {};
                }
            }
        }

        $scope.settings = settings;
        $scope.projectName = settings.project.name;
        $scope.activeTab = tabIds.indexOf($stateParams.activeTab) >= 0
            ? $stateParams.activeTab : 'scope';
        $scope.projectUrl = settings.project.linkUrl || '';
        var pageSearch = '';
        try {
            pageSearch = new $window.URL($window.location.href).searchParams.get('addKeyword');
        } catch (error) {}
        $scope.openTrackerKeywordBuilder = pageSearch === '1' || pageSearch === 'true' ||
            $stateParams.addKeyword === true || $stateParams.addKeyword === 'true' ||
            $stateParams.addKeyword === '1';
        $scope.general = {
            name: settings.project.name || '',
            domainType: settings.project.domainType || 'domain_with_subdomains'
        };
        $scope.saving = {general: false, audit: false};
        $scope.domainTypes = [
            {id: 'domain_with_subdomains', label: 'project.wizard.analyze.all', detail: 'project.wizard.domain.including.subdomains'},
            {id: 'domain_without_subdomains', label: 'project.wizard.domain', detail: 'project.wizard.only.specified.domain'},
            {id: 'prefix', label: 'project.wizard.path', detail: 'project.wizard.path.including.subfolders'},
            {id: 'exact_url', label: 'project.wizard.exact.url', detail: 'project.wizard.only.specified.url'}
        ];
        $scope.auditBooleanOptions = [
            {value: 1, label: 'yes'},
            {value: 0, label: 'no'}
        ];
        $scope.auditFrequencyOptions = [
            {value: 'daily', label: 'Daily'},
            {value: 'weekly', label: 'Weekly'},
            {value: 'monthly', label: 'Monthly'}
        ];
        $scope.auditWeekDays = [
            {value: 0, label: 'monday'}, {value: 1, label: 'tuesday'},
            {value: 2, label: 'wednesday'}, {value: 3, label: 'thursday'},
            {value: 4, label: 'friday'}, {value: 5, label: 'saturday'},
            {value: 6, label: 'sunday'}
        ];
        $scope.auditMonthDays = Array.apply(null, {length: 31}).map(function (_, index) {
            return index + 1;
        });
        $scope.auditTimes = TimezoneService.getAllTimeOptions();
        $scope.auditTimezones = TimezoneService.getAllTimezoneOptions();
        $scope.auditDepths = [1, 2, 3, 4, 5, 10, 25, 50, 100, 250, '∞'];
        $scope.auditResourceOptions = [];
        $scope.auditSpeeds = [
            {value: 1, key: 'seospider.ultra.slow'}, {value: 2, key: 'seospider.very.slow'},
            {value: 3, key: 'seospider.slow'}, {value: 4, key: 'seospider.moderate'},
            {value: 5, key: 'seospider.normal'}, {value: 6, key: 'seospider.fast'},
            {value: 7, key: 'seospider.very.fast'}, {value: 8, key: 'seospider.ultra.fast'}
        ];
        $scope.auditUserAgents = [
            {value: 'STO', label: 'SEO Tester Bot'},
            {value: 'GOOGLEBOT', label: 'GoogleBot'},
            {value: 'GOOGLEBOT_NEWS', label: 'GoogleBot News'},
            {value: 'GOOGLEBOT_MOBILE', label: 'GoogleBot Mobile'},
            {value: 'GOOGLEBOT_SMARTPHONE', label: 'GoogleBot Smartphone'},
            {value: 'BING', label: 'BingBot'},
            {value: 'CHROME', label: 'Chrome'},
            {value: 'OPERA', label: 'Opera'},
            {value: 'FIREFOX', label: 'Firefox'},
            {value: 'EDGE', label: 'Edge'}
        ];
        $scope.auditDraft = auditDraft(settings.spider);
        $scope.settingsTabs = [
            {id: 'scope', icon: 'ti-settings', label: 'project.settings.general', hint: 'project.settings.generalHint'},
            {id: 'audit', icon: 'ti-radar-2', label: 'project.settings.audit', hint: 'project.settings.auditHint'},
            {id: 'tracker', icon: 'ti-chart-line', label: 'project.settings.tracker', hint: 'project.settings.trackerHint'},
            {id: 'search-console', icon: 'ti-brand-google', label: 'project.settings.searchConsole', hint: 'project.settings.searchConsoleHint'},
            {id: 'competitors', icon: 'ti-users-group', label: 'project.settings.competitors', hint: 'project.settings.competitorsHint'}
        ];
        $scope.gsc = {
            checking: true,
            loadingProperties: false,
            connecting: false,
            propertyChanging: false,
            error: false,
            property: null,
            properties: []
        };

        $scope.setActiveTab = setActiveTab;
        $scope.saveGeneralSettings = saveGeneralSettings;
        $scope.saveAuditSettings = saveAuditSettings;
        $scope.goToPreviousPage = goToPreviousPage;
        $scope.showDropAlert = showDropAlert;
        $scope.connectSearchConsole = connectSearchConsole;
        $scope.changeSearchConsoleProperty = changeSearchConsoleProperty;
        $scope.disconnectSearchConsole = disconnectSearchConsole;
        $scope.refreshSearchConsole = loadSearchConsole;

        if (settings.spider) {
            settings.spider.respectRobots = settings.spider.respectRobots === 1 ||
                settings.spider.respectRobots === true;
            settings.spider.runScheduled = settings.spider.runScheduled === 1 ||
                settings.spider.runScheduled === true;
            settings.spider.scheduleFrequency = settings.spider.scheduleFrequency || 'daily';
            settings.spider.scheduleStartDay = Number(settings.spider.scheduleStartDay) || 0;
            settings.spider.scheduleStartHour = Number(settings.spider.scheduleStartHour) || 0;
            settings.spider.speed = Number(settings.spider.speed) || 5;
            settings.spider.maxDepth = settings.spider.maxDepth || 5;
            settings.spider.userAgent = settings.spider.userAgent || 'STO';
        }
        settings.project.competitors = settings.project.competitors ? settings.project.competitors.map(
            function (competitor) {
                return {
                    id: competitor.id,
                    url: competitor.linkUrl,
                    name: competitor.name,
                    domainType: competitor.domainType
                };
            }) : [];

        if ($scope.activeTab === 'search-console') {
            loadSearchConsole();
        }
        loadAuditResourceLimits();

        function setActiveTab(tabId) {
            if (tabIds.indexOf(tabId) < 0 || $scope.activeTab === tabId) {
                return;
            }
            $scope.activeTab = tabId;
            $state.go('app.project.settings', {
                projectId: settings.project.id,
                activeTab: tabId
            }, {notify: false, reload: false});
            if (tabId === 'search-console') {
                loadSearchConsole();
            }
        }

        function saveGeneralSettings() {
            if ($scope.saving.general || !$scope.general.name || !$scope.general.name.trim()) {
                return;
            }
            $scope.saving.general = true;
            ProjectsService.saveSettings(settings.project.id, {
                protocol: settings.project.protocol,
                linkUrl: settings.project.linkUrl,
                domainType: $scope.general.domainType,
                name: $scope.general.name.trim()
            }).then(function () {
                settings.project.name = $scope.general.name.trim();
                settings.project.domainType = $scope.general.domainType;
                $scope.projectName = settings.project.name;
                showCustomToast('project.wizard.project.saved', 'icon-checkmark st-green');
            }).catch(function () {
                showCustomToast('project.wizard.project.not.saved', 'icon-x st-red');
            }).finally(function () {
                $scope.saving.general = false;
            });
        }

        function saveAuditSettings() {
            if ($scope.saving.audit || !settings.spider) {
                return;
            }
            $scope.saving.audit = true;
            SeospiderService.saveSettings(settings.spider.id, {
                maxDepth: $scope.auditDraft.maxDepth,
                respectRobots: Number($scope.auditDraft.respectRobots) ? 1 : 0,
                speed: Number($scope.auditDraft.speed),
                userAgent: $scope.auditDraft.userAgent,
                resourcesLimit: Number($scope.auditDraft.resourcesLimit),
                scheduleFrequency: $scope.auditDraft.scheduleFrequency,
                scheduleStartDay: Number($scope.auditDraft.scheduleStartDay),
                scheduleStartHour: Number($scope.auditDraft.scheduleStartHour),
                scheduleTimezoneOffset: Number($scope.auditDraft.scheduleTimezoneOffset),
                runScheduled: Number($scope.auditDraft.runScheduled) ? 1 : 0
            }).then(function () {
                settings.spider.maxDepth = $scope.auditDraft.maxDepth;
                settings.spider.respectRobots = !!Number($scope.auditDraft.respectRobots);
                settings.spider.speed = Number($scope.auditDraft.speed);
                settings.spider.userAgent = $scope.auditDraft.userAgent;
                settings.spider.resourcesLimit = Number($scope.auditDraft.resourcesLimit);
                settings.spider.scheduleFrequency = $scope.auditDraft.scheduleFrequency;
                settings.spider.scheduleStartDay = Number($scope.auditDraft.scheduleStartDay);
                settings.spider.scheduleStartHour = Number($scope.auditDraft.scheduleStartHour);
                settings.spider.scheduleTimezoneOffset = Number($scope.auditDraft.scheduleTimezoneOffset);
                settings.spider.runScheduled = !!Number($scope.auditDraft.runScheduled);
                showCustomToast('project.wizard.project.saved', 'icon-checkmark st-green');
            }).catch(function () {
                showCustomToast('project.wizard.project.not.saved', 'icon-x st-red');
            }).finally(function () {
                $scope.saving.audit = false;
            });
        }

        function auditFlag(value) {
            return value === true || Number(value) === 1;
        }

        function auditDraft(spider) {
            spider = spider || {};
            var userAgent = String(spider.userAgent || 'STO');
            var allowedAgents = ['STO', 'GOOGLEBOT', 'GOOGLEBOT_NEWS', 'GOOGLEBOT_MOBILE',
                'GOOGLEBOT_SMARTPHONE', 'BING', 'CHROME', 'OPERA', 'FIREFOX', 'EDGE'];
            if (allowedAgents.indexOf(userAgent) < 0) userAgent = 'STO';
            return {
                runScheduled: auditFlag(spider.runScheduled) ? 1 : 0,
                respectRobots: auditFlag(spider.respectRobots) ? 1 : 0,
                scheduleFrequency: ['daily', 'weekly', 'monthly'].indexOf(spider.scheduleFrequency) >= 0
                    ? spider.scheduleFrequency : 'daily',
                scheduleStartDay: Number(spider.scheduleStartDay) || 0,
                scheduleStartHour: Number(spider.scheduleStartHour) || 0,
                scheduleTimezoneOffset: Number(spider.scheduleTimezoneOffset) || 0,
                maxDepth: spider.maxDepth || 5,
                resourcesLimit: Number(spider.resourcesLimit) || 100,
                speed: Number(spider.speed) || 5,
                userAgent: userAgent
            };
        }

        function loadAuditResourceLimits() {
            var fallback = [10, 25, 50, 100, 150, 200, 250, 500, 1000, 1500, 2000, 3000, 4000, 5000, 10000, 25000, 50000, 100000];
            UserService.limits().then(function (response) {
                var limit = 0;
                var limits = response && response.data && response.data.limits || [];
                limits.forEach(function (service) {
                    if (service.alias === 'seo-spider-limit') {
                        limit = Number(service.qtyAllowed) || 0;
                    }
                });
                setAuditResourceOptions(fallback, limit);
            }).catch(function () {
                setAuditResourceOptions(fallback, 100);
            });
        }

        function setAuditResourceOptions(values, limit) {
            var current = Number($scope.auditDraft && $scope.auditDraft.resourcesLimit) || 0;
            var list = values.slice();
            if (limit > 0 && list.indexOf(limit) < 0) list.push(limit);
            if (current > 0 && list.indexOf(current) < 0) list.push(current);
            $scope.auditResourceOptions = list.sort(function (a, b) {
                return a - b;
            }).map(function (value) {
                return {
                    value: value,
                    locked: !!limit && value > limit
                };
            });
        }

        function loadSearchConsole() {
            $scope.gsc.checking = true;
            $scope.gsc.error = false;
            SearchConsoleService.getProjectConnection(settings.project.id).then(function (connection) {
                $scope.gsc.property = connection && connection.propertyUrl || null;
                $scope.gsc.checking = false;
                if (!$scope.gsc.property) {
                    $scope.gsc.properties = [];
                    return;
                }
                $scope.gsc.loadingProperties = true;
                return SearchConsoleService.getProjectProperties(settings.project.id)
                    .then(function (properties) {
                        $scope.gsc.properties = properties && properties.items || [];
                        if (properties && properties.selected) {
                            $scope.gsc.property = properties.selected;
                        }
                    })
                    .catch(function () {
                        $scope.gsc.properties = [];
                    })
                    .finally(function () {
                        $scope.gsc.loadingProperties = false;
                    });
            }).catch(function () {
                $scope.gsc.checking = false;
                $scope.gsc.error = true;
            });
        }

        function connectSearchConsole() {
            if ($scope.gsc.connecting) {
                return;
            }
            $scope.gsc.connecting = true;
            $scope.gsc.error = false;
            SearchConsoleService.connectProject({
                id: settings.project.id,
                workspaceId: settings.project.workspaceId,
                name: settings.project.name,
                url: settings.project.linkUrl
            }, {
                returnState: 'app.project.settings',
                returnParams: {
                    projectId: settings.project.id,
                    activeTab: 'search-console'
                }
            }).catch(function () {
                $scope.gsc.error = true;
                $scope.gsc.connecting = false;
            });
        }

        function changeSearchConsoleProperty(propertyUrl) {
            if (!propertyUrl || $scope.gsc.propertyChanging) {
                return;
            }
            $scope.gsc.propertyChanging = true;
            $scope.gsc.error = false;
            SearchConsoleService.connectProjectProperty(settings.project.id, propertyUrl)
                .then(function () {
                    showCustomToast('project.wizard.project.saved', 'icon-checkmark st-green');
                })
                .catch(function () {
                    $scope.gsc.error = true;
                })
                .finally(function () {
                    $scope.gsc.propertyChanging = false;
                });
        }

        function disconnectSearchConsole() {
            if (!$scope.gsc.property ||
                !$window.confirm($translate.instant('project.settings.searchConsoleDisconnectConfirm'))) {
                return;
            }
            $scope.gsc.connecting = true;
            SearchConsoleService.disconnectProject(settings.project.id).then(function () {
                $scope.gsc.property = null;
                $scope.gsc.properties = [];
                showCustomToast('project.settings.searchConsoleDisconnected', 'icon-checkmark st-green');
            }).catch(function () {
                $scope.gsc.error = true;
            }).finally(function () {
                $scope.gsc.connecting = false;
            });
        }

        function showDropAlert(project, event) {
            project.projectId = project.id;
            $mdDialog.show({
                controller: 'ProjectDeleteProjectCtrl',
                templateUrl: 'app/modules/project/dialogs/delete-project/delete-project.html',
                targetEvent: event,
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                locals: {project: project}
            }).then(function () {
                if ($scope.backState === 'app.project.detail.tracker' ||
                    $scope.backState === 'app.project.settings') {
                    $state.go('app.welcome');
                    return;
                }
                goToPreviousPage();
            });
        }

        function goToPreviousPage() {
            if ($scope.backState) {
                $state.go($scope.backState, $scope.backParams);
                return;
            }
            $window.history.back();
        }

        function showCustomToast(string, classIcon) {
            $mdToast.show({
                template: '<md-toast layout="row" flex class="md-toast">' +
                    '<div><i class="' + classIcon + ' m-r-sm"></i></div>' +
                    '<div>' + $translate.instant(string) + '</div>' +
                    '</md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }

    Controller.$inject = [
        '$scope',
        'settings',
        '$stateParams',
        '$state',
        '$mdToast',
        '$translate',
        'ProjectsService',
        'SeospiderService',
        'SearchConsoleService',
        'UserService',
        'TimezoneService',
        '$mdDialog',
        '$rootScope',
        '$window'
    ];
    return Controller;
});
